import React from 'react';
import styled from 'styled-components';
import { Avatar, Modal } from 'antd';
import { AiOutlineUser } from 'react-icons/ai';
import { CredusText, color } from 'ui';

import { Tag } from '../tables/CandidateDataTable';
import { CandidateData } from '../../../../../contexts/CandidateContext';

interface CandidateDataProps {
  showData: boolean;
  candidate: CandidateData;
  setShowData: React.Dispatch<React.SetStateAction<boolean>>;
}

const CandidateDataModal = ({
  showData,
  setShowData,
  candidate,
}: CandidateDataProps) => {
  const {
    surname,
    firstName,
    email,
    category,
    gender,
    pictureUrl,
    status,
    registeredCourse,
    phone,
    candidateNumber,
  } = candidate;
  const candidateData = [
    { label: 'First Name', value: firstName },
    { label: 'Surname', value: surname },
    { label: 'Gender', value: gender },
    { label: 'Candidate ID', value: candidateNumber },
    { label: 'Email', value: email },
    { label: 'Phone', value: phone },
    { label: 'Exam Category', value: category },
    { label: 'Test Code', value: registeredCourse },
  ];
  return (
    <Modal
      title=""
      width={'820px'}
      open={showData}
      footer=""
      onCancel={() => setShowData(false)}
    >
      <Container>
        <LeftDiv>
          {pictureUrl ? (
            <Avatar src={pictureUrl} size={140} />
          ) : (
            <Avatar icon={<AiOutlineUser />} size={140} />
          )}
          <CredusText size="sm" color="#A39F9F">
            Status
          </CredusText>
          <Tag background="#FDC453" radius="6px" pad="8px">
            {' '}
            <CredusText size="sm" color={color.white}>
              {status}
            </CredusText>
          </Tag>
        </LeftDiv>
        <RightDiv>
          {candidateData.map((el) => (
            <DataDiv>
              <CredusText color="#878787" size="sm">
                {el.label}
              </CredusText>
              <CredusText color="#000929" size="lg">
                {el.value}
              </CredusText>
            </DataDiv>
          ))}
        </RightDiv>
      </Container>
    </Modal>
  );
};

export default CandidateDataModal;

const Container = styled.div`
  display: flex;
`;
const LeftDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 3rem;
  padding-left: 1.5rem;
  border-right: 1px solid rgba(224, 222, 247, 0.5);
`;
const RightDiv = styled.div`
  display: flex;
  padding: 3rem;
  flex-wrap: wrap;
  gap: 3rem;
`;

const DataDiv = styled.div`
  width: 120px;
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
`;
